import React, { useState, useCallback } from "react";
import "./App.css";
import { MotionConfig } from "framer-motion";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import TransactWorldPreloader from "./components/TransactWorldPreloader";
import TawkToChat from "./components/TawkToChat";
import { Toaster } from "./components/ui/toaster";
import HomePage from "./pages/HomePage";
import CookiePolicy from "./pages/CookiePolicy";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsConditions from "./pages/TermsConditions";
import TermsOfUse from "./pages/TermsOfUse";
import ComplaintsPolicy from "./pages/ComplaintsPolicy";

function ScrollToTop() {
  const { pathname } = useLocation();

  React.useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);

  return null;
}

function App() {
  const [showPreloader, setShowPreloader] = useState(true);
  const handlePreloaderComplete = useCallback(() => {
    setShowPreloader(false);
  }, []);

  return (
    <BrowserRouter>
      <MotionConfig reducedMotion="user">
        <div className="App">
          {showPreloader && (
            <TransactWorldPreloader duration={3000} onComplete={handlePreloaderComplete} />
          )}
          <ScrollToTop />
          <Navbar />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/cookie-policy" element={<CookiePolicy />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsConditions />} />
            <Route path="/terms-of-use" element={<TermsOfUse />} />
            <Route path="/complaints-policy" element={<ComplaintsPolicy />} />
          </Routes>
          <Footer />
          <TawkToChat />
          <Toaster />
        </div>
      </MotionConfig>
    </BrowserRouter>
  );
}

export default App;